import { render, staticRenderFns } from "./fbpBand.vue?vue&type=template&id=522fc1b0&scoped=true&lang=html"
import script from "./fbpBand.vue?vue&type=script&lang=js"
export * from "./fbpBand.vue?vue&type=script&lang=js"
import style0 from "./fbpBand.vue?vue&type=style&index=0&id=522fc1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fc1b0",
  null
  
)

export default component.exports